export const UrlConstants = {
  // 社名アイコンURL
  COMPANY_ICON_URL: 'page0001',

  // よくある質問URL
  FAQ_URL: 'page0006',

  // 特別勘定運用ポータルURL
  SPECIAL_ACCOUNT_OPERATION_PORTAL_URL: 'page0002',
};
